import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import SessionRequest from "./sessionRequest";
import UpcomingSession from "./upcomingSession";
import Performance from "./performance";
import Availability from "./availability";
import Notification from "./notification";
import Tips from "./Tips";
import { connect } from "react-redux";

import {
  analytics,
  getallSessions,
  notifications,
  availability,
  TipsApi,
} from "./../../apis/tutors";
class Dashboard extends Component {
  constructor() {
    super();

    this.state = {
      performance: {},
      allSessions: [],
      availability: [],
      availabilityLoading: false,
      TipsData: [],
    };
  }

  getAvailability = (data) => {
    this.setState({ availabilityLoading: true });
    availability({ token: data.token, id: data.id })
      .then((res) =>
        this.setState({
          availability: res.data,
          availabilityLoading: false,
        })
      )
      .catch((err) =>
        this.setState({
          error: err,
          availabilityLoading: false,
        })
      );
  };
  getNotifications = (data) => {
    notifications({ token: data.token, id: data.id })
      .then((res) =>
        this.setState({
          notifations: res.data,
        })
      )
      .catch((err) =>
        this.setState({
          error: err,
        })
      );
  };
  getSessions = (data) => {
    getallSessions({ token: data.token, id: data.id })
      .then((res) =>
        this.setState({
          allSessions: res.data,
        })
      )
      .catch((err) =>
        this.setState({
          error: err,
        })
      );
  };
  getAnalytics = (data) => {
    analytics({ token: data.token, id: data.id })
      .then((res) =>
        this.setState({
          performance: res.data,
        })
      )
      .catch((err) =>
        this.setState({
          error: err,
        })
      );
  };

  getTips = (data) => {
    TipsApi({ token: data.token, id: data.id })
      .then((res) =>
        this.setState({
          TipsData: res.data,
        })
      )
      .catch((err) =>
        this.setState({
          error: err,
        })
      );
  };

  componentDidMount = () => {
    // get Token
    let token = JSON.parse(localStorage.getItem("userDetail"));
    token = `Bearer ${token?.token}`;

    // analytics
    this.getAnalytics({ id: "1234", token });

    // getallSessions
    this.getSessions({ id: "1234", token });

    // notifications
    this.getNotifications({ id: "1234", token });

    // getAvailability
    this.getAvailability({ id: "1234", token });

    // getTips
    this.getTips({ id: "1234", token });
  };
  render() {
    const {
      notifations,
      availability,
      performance,
      allSessions,
      availabilityLoading,
      TipsData,
    } = this.state;

    return (
      <div className="container">
        <div className="Dashboard-div">
          <p className="head-line">Dashboard</p>
          <Row className="flex-center m-0">
            <Col lg={7} md={12} sm={12} xs={12} className="p-0">
              <Row className="m-0">
                <Col lg={12} md={12} sm={12} xs={12} className="p-0">  
                  <Row className="flex-center m-0">
                        <Col lg={12} md={12} sm={12} xs={12} className="session-request">
                            <p className="learning-headline">Lesson Requests</p>
                          {allSessions?.length &&
                            allSessions.map((session, index) => {
                              return session?.status === "new" ? (
                                <SessionRequest
                                  session={session}
                                  allSessions={allSessions}
                                  index={index}
                                  key={index}
                                />
                              ) : (
                                ""
                              );
                            })}
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12} className="p-0">
                          <Performance performance={performance} />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12} className="p-0">
                          <Tips TipsData={TipsData} />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12} className="p-0">
                          <div className="upcoming-session session-request">
                            <Row className="flex-center m-0">
                              <Col className="p-0" lg={12} md={12} sm={12} xs={12}>
                                <Row
                                  className="flex-center m-0"
                                  style={{ marginBottom: "25px" }}
                                >
                                  <Col className="p-0" lg={6} md={6} sm={12} xs={12}>
                                    <p className="learning-headline">Upcoming Sessions</p>
                                  </Col>
                                </Row>

                                {allSessions?.length &&
                                  allSessions.map((session, index) => {
                                    return session?.status !== "new" ? (
                                      <UpcomingSession
                                        key={index}
                                        session={session}
                                      />
                                    ) : (
                                      ""
                                    );
                                  })}
                              </Col>
                            </Row>
                            <div
                              className="ex-end-txt"
                            >
                              Go to all upcoming lessons
                            </div>
                          </div>
                          </Col>
                      </Row>
                    </Col>
              </Row>
            </Col>
            <Col className="md-size-nopad p-r-0" lg={5} md={12} sm={12} xs={12}>
              <Row className="m-0">
                <Col lg={12} md={12} sm={12} xs={12} className="p-0">
                  <Availability
                    isSmaller={true}
                    availability={availability}
                    loading={availabilityLoading}
                    user={this?.props?.user}
                    isDashboard={true}
                  />
                </Col>
                <Col className="p-0" lg={12} md={12} sm={12} xs={12}>
                <Notification notifations={notifations} />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="m-0" style={{ paddingLeft: "4px" }}>
            <span
             className="dashb-end-text"
            >
              Give us feedback
            </span>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    UserReducer: { user },
  } = state;
  return {
    user,
  };
};
export default connect(mapStateToProps, null)(Dashboard);
